export type ReportMetricSummary = {
  gross_sales_cents?: number | null;
  taxes_cents?: number | null;
  tip_cents?: number | null;
  refund_amount_cents?: number | null;
  net_revenue_cents?: number | null;
};

export function refundsCents(summary: ReportMetricSummary | null | undefined): number {
  return Math.abs(summary?.refund_amount_cents ?? 0);
}

export function grossSalesCents(summary: ReportMetricSummary | null | undefined): number {
  return (summary?.gross_sales_cents ?? 0) - (summary?.taxes_cents ?? 0) + refundsCents(summary);
}

export function netSalesCents(summary: ReportMetricSummary | null | undefined): number {
  return grossSalesCents(summary) - refundsCents(summary);
}

export function totalCollectedCents(summary: ReportMetricSummary | null | undefined): number {
  return summary?.gross_sales_cents ?? 0;
}

export function expectedDepositCents(summary: ReportMetricSummary | null | undefined): number {
  return summary?.net_revenue_cents ?? 0;
}
